<!-- row 1 -->
<div class="footer_bottom">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center footer_menu">
                <h3>For more <strong>information call us at 1-800-727-5051 or <a [routerLink]="['/contact']" href="/contact"><span style="color:red;"><u>Contact Us</u></span></a> today!</strong></h3>
            </div>
        </div>
    </div>
</div>

<!-- Start Footer -->
<footer class="footer-box">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-4">
                <div class="footer_blog footer_menu">
                    <h3>Navigation</h3>
                    <ul>
                      <li><a [routerLink]="['/']" href="/" (click)="topposition()">Home</a></li>
                      <li><a [routerLink]="['/ourcompany']" href="/ourcompany" (click)="topposition()">Our Company</a></li>
                      <li><a [routerLink]="['/contact']" href="/contact" (click)="topposition()">Contact Us</a></li>
                      <li><a [routerLink]="['/blog']" href="/blog" (click)="topposition()">Safety 101 Blog</a></li>
                    </ul>
                 </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="footer_blog footer_menu">
                    <h3>Our Services</h3>
                    <ul>
                      <li><a [routerLink]="['/safetyprogram']" href="/safetyprogram" (click)="topposition()">Safety Programs</a></li>
                      <li><a [routerLink]="['/safetytraining']" href="/safetytraining" (click)="topposition()">Safety Trainings</a></li>
                      <li><a [routerLink]="['/safetyinspection']" href="/safetyinspection" (click)="topposition()">On-Site Inspections</a></li>
                    </ul>

                    <div style="min-height: 10px;">&nbsp;
                    </div>
                    <span>Follow Us On Social Media</span>
                    <ul class="social_icon margin-top_20">
                        <li><a href="https://www.facebook.com/sficompliance" target="_blank"><i class="fa fa-facebook-f"></i></a></li>
                        <li><a href="https://twitter.com/sficompliance" target="_blank"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/sfi-compliance" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                        <li><a href="https://www.instagram.com/sficompliance" target="_blank"><i class="fa fa-instagram"></i></a></li>
                    </ul>
                 </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="footer_blog footer_menu">
                    <h3 style="color:red;">Newsletter</h3>
                    <ul>
                        <li><u><a target="_blank" 
                            href="https://lp.constantcontactpages.com/sl/g4w3LwY">Subscribe to the SFI Safety Sentinel to stay up-to-date and get access to many safety resources.</a></u></li>
                    </ul>                    
                 </div>
            </div>
        </div>

    </div>
</footer>
<!-- End Footer -->


<!-- end section-->
<div class="footer_bottom">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <p class="crp">© {{current}} SFI Safety, LLC | All Rights Reserved.</p>
                <ul class="bottom_menu">
                    <li><a href="/terms-of-service"><u>Terms of Service</u></a></li>
                    <!-- <li><a href="/eula"><u>EULA</u></a></li>
                    <li><a href="/privacy"><u>Privacy Policy</u></a></li> -->
                </ul>
            </div>
        </div>
    </div>
</div>

<a href="#" class="back-to-top"><i class="fa fa-angle-up"></i></a>
<div id="preloader"></div>